<template>
  <v-card>
    <v-toolbar
      class="px-4"
      style="
        z-index: 99999;
        background: linear-gradient(60deg, #66bb6a, #43a047);
        color: white;
      "
    >
      <span
        style="
          font-size: 1.125rem;
          line-height: 1.4em;
          font-weight: 300;
          font-size: 18px;
        "
        >{{$t('customizeResponse.configureResponse')}} {{ outputResponseIndex + 1 }}
      </span>
      <v-spacer></v-spacer>
      <md-button
        @click="$emit('close-customize-response-dialog')"
        class="md-simple md-just-icon"
      >
        <md-icon>close</md-icon>
      </md-button>
    </v-toolbar>
    <v-card-text class="pa-0">
      <md-card-content>
        <div
          style="
            padding: 28px 32px 28px 32px;
            width: 100%;
          "
        >
          <div class="md-layout">
            <div
              class="md-layout-item titleLabel colorDark"
              style="margin: auto;"
            >
              {{$t('customizeResponse.jsonEditMode')}}
            </div>
            <div
              class="md-layout-item md-form-label md-size-15"
              style="padding: 0; margin: auto;"
              :class="{
                'text-success': jsonOpen,
                'text-danger': !jsonOpen,
              }"
            >
              {{
                jsonOpen
                  ? $t('commonWords.enabled')
                  : $t('commonWords.disabled')
              }}
            </div>
            <div class="md-layout-item md-size-15">
              <md-switch
                :disabled="isNotCheckedOut"
                v-model="jsonOpen"
              ></md-switch>
            </div>
          </div>
          <div class="md-layout">
            <div class="md-layout-item">
             {{$t('customizeResponse.activateThiMmodeToBeAbleToEditTheContext')}}
            </div>
          </div>
        </div>
        <Conditions
          v-model="outputResponseItem.conditions"
          :context="context"
          :intents="intents"
          :entities="entities"
        />
        <template v-if="jsonOpen">
          <div style="padding: 0 32px; width: 100%;">
            <v-row no-gutters style="justify-content: space-between;">
              <v-col cols="6">
                <div
                  class="titleLabel colorDark"
                  style="margin-top: 30px; margin-bottom: 12px;"
                >
                  {{$t('customizeResponse.jsonEditing')}}
                </div>
              </v-col>
              <v-col cols="auto" style="align-self: flex-end;">
                <md-menu
                  md-direction="bottom-end"
                  md-size="medium"
                  md-align-trigger
                  style="margin-bottom: 6px;"
                >
                  <v-btn md-menu-trigger icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                  <md-menu-content>
                    <md-menu-item @click="toggleJSON()"
                      >{{$t('customizeResponse.closeJsonEdit')}}</md-menu-item
                    >
                  </md-menu-content>
                </md-menu>
              </v-col>
            </v-row>
            <div style="padding: 0 12px 0 0; width: 100%;">
              <v-row no-gutters style="justify-content: space-between;">
                <v-col :class="{ 'disable-click': isNotCheckedOut }" cols="12">
                  <JsonEditor :data="outputResponseItem" @update='updateResponseItemFromJson' :type="'customize'" />
                </v-col>
              </v-row>
            </div>
          </div>
        </template>
        <template v-else>
          <div style="padding: 0; width: 100%;">
            <collapse
              :collapse="[
                this.$t('customizeResponse.thenSetTheContext'),
                this.$t('customizeResponse.thenDefineTheActions'),
                this.$t('customizeResponse.theAssistantResponds')
              ]"
              :titleStyle="{ color: '#393939', fontSize: '20px', lineHeight: '30px', fontWeight: '400', paddingLeft: '32px' }"
              :containerPadding="'0 32px'"
              icon="keyboard_arrow_down"
              color-collapse="success"
            >
              <template slot="md-collapse-pane-1">
                <Context
                  v-model="outputResponseItem.context"
                  @toggleJSON="toggleJSON()"
                />
              </template>
              <template slot="md-collapse-pane-2">
                <template v-if="!noAction">
                  <v-tabs
                    v-model="actionsTab"
                    show-arrows
                    style="
                      color: #6200ea !important;
                      caret-color: #6200ea !important;
                    "
                  >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab v-for="i in tabs" :key="i" :href="`#tab-${i}`">
                      Action {{ i }}
                      <v-icon
                        v-if="!isNotCheckedOut"
                        @click.stop="removeTab(i)"
                        small
                        color="red"
                        style="margin-left: 4px;"
                      >
                        mdi-close-circle</v-icon
                      >
                    </v-tab>
                    <div
                      v-if="!isNotCheckedOut"
                      class="v-tab v-tab--active"
                      aria-selected="true"
                      @click="newTab()"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </div>
                    <v-tab-item
                      v-for="i in tabs"
                      :key="i"
                      :value="'tab-' + i"
                    >
                      <Actions
                        v-model="outputResponseItem.actions[i - 1]"
                        :readOnly="isNotCheckedOut"
                      />
                    </v-tab-item>
                  </v-tabs>
                </template>
                <template v-else>
                  <div>
                    {{$t('customizeResponse.thereIsNoActionAssignedYet')}}
                  </div>
                  <v-row
                    no-gutters
                    style="
                      padding: 12px 0 0 0;
                      justify-content: space-between;
                    "
                  >
                    <v-col cols="auto">
                      <md-button
                        :disabled="isNotCheckedOut"
                        @click="newTab()"
                        style="float: left;"
                        class="md-facebook md-sm"
                      >
                        <img
                          src="../../public/img/plus.png"
                          style="
                            height: 26px;
                            width: 26px;
                            margin-right: 10px;
                            filter: invert(100%);
                          "
                        />
                        <span>{{$t('customizeResponse.addAnAction')}}</span>
                      </md-button>
                    </v-col>
                  </v-row>
                  <v-row no-gutters style="padding-top: 12px;">
                    <v-divider></v-divider>
                  </v-row>
                </template>
              </template>
              <template slot="md-collapse-pane-3">
                <template v-if="outputResponseItem.output">
                  <div
                    v-for="(response, i) in outputResponseItem.output.generic"
                    :key="i"
                    :style="i % 2 == 0 ? {} : { backgroundColor: '#f7f7f7' }"
                    style="width: 100%; padding-bottom: 24px;"
                  >
                    <v-row v-if='i > 0' no-gutters>
                      <v-divider></v-divider>
                    </v-row>
                    <v-row
                      no-gutters
                      style="
                        width: 100%;
                        justify-content: space-between;
                      "
                    >
                      <v-col xs="12" sm="4" cols="4">
                        <md-field style="margin-top: 8px;">
                          <md-select
                            :disabled="isNotCheckedOut"
                            style="
                              background-color: rgb(244, 244, 244);
                              padding-left: 4px;
                            "
                            v-model="response.response_type"
                          >
                            <md-option value="text">{{$t('customizeResponse.text')}}</md-option>
                          </md-select>
                        </md-field>
                      </v-col>
                      <v-col cols="auto" style="align-self: center;">
                        <span
                          :class="{ 'disable-click': isNotCheckedOut }"
                          @click="moveUp(i, outputResponseIndex)"
                        >
                          <md-icon
                            :style="
                              isFirst(i, outputResponseIndex)
                                ? { color: 'gray', cursor: '' }
                                : { color: 'blue', cursor: 'pointer' }
                            "
                            style="padding: 3px 5px; margin: 3px;"
                            >expand_less</md-icon
                          >
                          <md-tooltip
                            v-if="!isFirst(i, outputResponseIndex)"
                            md-direction="left"
                            >{{$t('customizeResponse.moveUp')}}</md-tooltip
                          >
                        </span>
                        <span
                          :class="{ 'disable-click': isNotCheckedOut }"
                          @click="moveDown(i, outputResponseIndex)"
                        >
                          <md-icon
                            :style="
                              isLast(i, outputResponseIndex)
                                ? { color: 'gray', cursor: '' }
                                : { color: 'blue', cursor: 'pointer' }
                            "
                            style="padding: 3px 5px; margin: 3px;"
                            >expand_more</md-icon
                          >
                          <md-tooltip
                            v-if="!isLast(i, outputResponseIndex)"
                            md-direction="left"
                            >{{$t('customizeResponse.moveDown')}}</md-tooltip
                          >
                        </span>
                        <span
                          :class="{ 'disable-click': isNotCheckedOut }"
                          @click="deleteResponse(i, outputResponseIndex)"
                        >
                          <md-icon
                            style="
                              cursor: pointer;
                              color: #f44336;
                              padding: 3px 5px;
                              margin: 3px;
                            "
                            >delete</md-icon
                          >
                          <md-tooltip md-direction="left"
                            >{{$t('customizeResponse.removeAnswerType')}}</md-tooltip
                          >
                        </span>
                      </v-col>
                    </v-row>
                    <div
                      v-for="(value, j) in addValueText(response.values, i)"
                      :key="j"
                      style="padding: 16px 0 0 0; width: 100%;"
                    >
                      <v-row no-gutters>
                        <v-col cols="11">
                          <div class="contQuill">
                            <quill-editor
                              :class="{ 'disable-click': isNotCheckedOut }"
                              class="editor"
                              ref="myTextEditor"
                              :value="createHtml(value.text)"
                              :options="editorOption"
                              @change="
                                onEditorChange($event, i, j, outputResponseIndex)
                              "
                            />
                          </div>
                        </v-col>
                        <v-col cols="1" style="align-self: center;">
                          <span
                            v-if="j == 0 && value.text == ''"
                            :class="{ 'disable-click': isNotCheckedOut }"
                          >
                            <md-icon style="color: gray; padding-left: 24px;"
                              >remove_circle</md-icon
                            >
                          </span>
                          <span
                            v-else
                            :class="{ 'disable-click': isNotCheckedOut }"
                            @click="deleteVariations(i, j, outputResponseIndex)"
                          >
                            <md-icon
                              style="
                                cursor: pointer;
                                color: #f44336;
                                padding-left: 24px;
                              "
                              >remove_circle</md-icon
                            >
                            <md-tooltip md-direction="bottom"
                              >{{$t('customizeResponse.removeAnswerVariation')}}</md-tooltip
                            >
                          </span>
                        </v-col>
                      </v-row>
                    </div>
                    <div
                      style="
                        padding-top: 16px;
                        padding: 16px 0 0 0;
                        width: 100%;
                      "
                    >
                      <span
                        :class="{ 'disable-click': isNotCheckedOut }"
                        @click="addVariations(i, outputResponseIndex)"
                        style="color: #4caf50; cursor: pointer;"
                      >
                        <md-icon style="color: #4caf50;">add_circle</md-icon>
                        <div style="line-height: 24px; display: inline;">
                          &nbsp;{{$t('customizeResponse.add')}}
                        </div>
                        <md-tooltip md-direction="bottom"
                          >{{$t('customizeResponse.addAnswerVariation')}}</md-tooltip
                        >
                      </span>
                    </div>
                    <div
                      style="
                        padding-top: 16px;
                        padding: 16px 0 0 0;
                        width: 100%;
                      "
                    >
                      {{$t('customizeResponse.responseVariationsAreDefinedFor')}}
                      <b>{{ variationType(response.selection_policy).selected }}.</b>
                      {{$t('customizeResponse.setTo')}}
                      <span
                        :class="{ 'disable-click': isNotCheckedOut }"
                        @click="
                          changeVariationType(
                            i,
                            variationType(response.selection_policy).variations[0],
                            outputResponseIndex
                          )
                        "
                        class="variationSelected"
                        >{{
                          variationType(response.selection_policy).variations[0]
                        }}</span
                      >
                      {{$t('customizeResponse.or')}}
                      <span
                        :class="{ 'disable-click': isNotCheckedOut }"
                        @click="
                          changeVariationType(
                            i,
                            variationType(response.selection_policy).variations[1],
                            outputResponseIndex
                          )
                        "
                        class="variationSelected"
                        >{{
                          variationType(response.selection_policy).variations[1]
                        }}</span
                      >
                    </div>
                  </div>
                </template>
                <div style="padding: 0 0 24px 0; width: 100%;">
                  <v-row no-gutters style="padding: 0;">
                    <v-divider></v-divider>
                  </v-row>
                  <v-row
                    no-gutters
                    style="padding: 12px 0 0 0; justify-content: space-between;"
                  >
                    <v-col cols="auto">
                      <md-button
                        :disabled="isNotCheckedOut"
                        @click="addResponseCustomized(outputResponseIndex)"
                        style="float: left;"
                        class="md-facebook md-sm"
                      >
                        <img
                          src="../../public/img/plus.png"
                          style="
                            height: 26px;
                            width: 26px;
                            margin-right: 10px;
                            filter: invert(100%);
                          "
                        />
                        <span>{{$t('customizeResponse.addAnswerType')}}</span>
                      </md-button>
                    </v-col>
                  </v-row>
                  <v-row no-gutters style="padding-top: 12px;">
                    <v-divider></v-divider>
                  </v-row>
                </div>
              </template>
            </collapse>
          </div>
        </template>
        <div
          style="
            padding: 0 32px 12px 32px;
            width: 100%;
          "
        >
          <v-row no-gutters style="justify-content: space-between;">
            <v-col cols="12">
              <div
                class="titleLabel colorDark"
                style="margin-top: 12px; margin-bottom: 12px;"
              >
                {{$t('customizeResponse.theAssistantMust')}}
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters style="justify-content: space-between;">
            <v-col cols="4">
              <md-field style="margin-top: 8px;">
                <md-select
                  :disabled="isNotCheckedOut"
                  :placeholder="$t('customizeResponse.select')"
                  style="
                    background-color: rgb(244, 244, 244);
                    padding-left: 4px;
                  "
                  @md-selected="changedSelectedBehavior()"
                  v-model="selectedBehavior"
                >
                  <md-option value="default"
                    >{{$t('customizeResponse.nodeConfigurationDefault')}}</md-option
                  >
                  <md-option value="jump_to">{{$t('customizeResponse.goTo')}}</md-option>
                </md-select>
              </md-field>
            </v-col>
            <v-col
              id="removeJumpNode"
              v-if="
                outputResponseItem.next_step.behavior === 'jump_to' &&
                !isNotCheckedOut
              "
              cols="auto"
            >
              <md-button
                @click="selectedBehavior = 'default'"
                class="md-simple md-just-icon"
              >
                <md-icon>close</md-icon>
              </md-button>
            </v-col>
          </v-row>
          <v-row no-gutters style="justify-content: space-between;">
            <v-col
              v-if="outputResponseItem.next_step.behavior === 'jump_to'"
              cols="12"
            >
              <md-card
                id="node-preview"
                class="node-content drag-trigger before-parent node-card-class"
                style="cursor: pointer; position: relative; width: 700px;"
              >
                <v-row no-gutters>
                  <v-col
                    @click="
                      scrollToNode(outputResponseItem.next_step.dialog_node)
                    "
                    cols="auto"
                    style="align-items: center;"
                  >
                    <button id="expand-button-id" class="button-expand">
                      <md-icon
                        v-if="nodeMap[outputResponseItem.next_step.dialog_node] &&
                          nodeMap[outputResponseItem.next_step.dialog_node]
                            .children.length > 0
                        "
                        class="icon-expand not-expanded"
                      >
                        chevron_right
                      </md-icon>
                      <md-icon v-else class="icon-expand">remove</md-icon>
                    </button>
                  </v-col>
                  <v-col
                    @click="
                      scrollToNode(outputResponseItem.next_step.dialog_node)
                    "
                    cols="auto"
                  >
                    <v-card style="width: 626px;" flat>
                      <v-list-item
                        v-if="nodeMap[outputResponseItem.next_step.dialog_node] &&
                          nodeMap[outputResponseItem.next_step.dialog_node].data
                            .title
                        "
                        two-line
                      >
                        <v-list-item-content>
                          <v-list-item-title class="headline mb-1">
                            {{
                              nodeMap[outputResponseItem.next_step.dialog_node]
                                .data.title
                            }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            {{$t('customizeResponse.ifYouRecognize')}}
                            <b>{{
                              loopAssisRecNode(
                                nodeMap[outputResponseItem.next_step.dialog_node]
                              )
                            }}</b>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item v-else>
                        <v-list-item-content>
                          <v-list-item-title class="headline mb-1">
                            {{ nodeMap[outputResponseItem.next_step.dialog_node] ?
                              loopAssisRecNode(
                                nodeMap[
                                  outputResponseItem.next_step.dialog_node
                                ]
                              ) : ''
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-card-actions>
                        <v-chip-group column active-class="primary--text">
                          <v-chip small>
                            {{
                              respostas(
                                nodeMap[
                                  outputResponseItem.next_step.dialog_node
                                ]
                              )
                            }}{{ ' ' }}
                            {{$t('customizeResponse.answers')}}
                          </v-chip>
                          <v-chip small>
                            {{nodeMap[outputResponseItem.next_step.dialog_node]?
                              returnContext(
                                nodeMap[
                                  outputResponseItem.next_step.dialog_node
                                ]
                              ) : ''
                            }}
                            {{ ' ' }}
                            {{$t('customizeResponse.contextDefined')}}
                          </v-chip>
                          <v-chip
                            color="#3b5998"
                            dark
                            text-color="#ffffff"
                            v-if="nodeMap[outputResponseItem.next_step.dialog_node] &&
                              nodeMap[outputResponseItem.next_step.dialog_node]
                                .data.jumpTo
                            "
                            small
                          >
                            <v-icon small left>mdi-logout-variant</v-icon>
                            {{$t('customizeResponse.jumpTo')}}
                          </v-chip>
                        </v-chip-group>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </md-card>
            </v-col>
          </v-row>
        </div>
      </md-card-content>
    </v-card-text>
    <v-card-actions>
      <!-- <md-button
        @click="$emit('close-customize-response-dialog')"
        class="md-danger md-simple"
        style="margin-right: 8px;"
      >
        <span>{{ $t("commonWords.cancel") }}</span>
      </md-button> -->
      <v-spacer></v-spacer>
      <md-button
        @click="$emit('close-customize-response-dialog', outputResponseItem)"
        class="md-success"
      >
        <span>OK</span>
      </md-button>
    </v-card-actions>
  </v-card>
</template>

<script>
import responseMixin from './mixins/responseMixin'
import JsonEditor from './JsonEditor'
import Collapse from '@/components/Reuse/Collapse'
import Context from '@/components/EditDialog/Context'
import Actions from '@/components/EditDialog/Actions'
import Conditions from '@/components/EditDialog/Conditions'
import { mapFields } from 'vuex-map-fields'
export default {
  props: [
    'nodeData',
    'nodeMap',
    'outputResponseItem',
    'outputResponseIndex',
    'intents',
    'entities',
    'context'
  ],
  mixins: [responseMixin],
  components: {
    JsonEditor,
    Collapse,
    Context,
    Actions,
    Conditions
  },
  data () {
    return {
      attAdd: '',
      jsonOpen: false,
      selectedBehavior: 'skip_user_input',
      noAction: true,
      actionsTab: 'tab-1',
      tabs: 0
    }
  },
  watch: {
    selector (newValue) {
      if (newValue !== '') {
        if (this.selectNodeModeValue === 0) {
          this.nodeData.data.next_step.dialog_node = this.dialog_node
          this.nodeData.data.next_step.selector = this.selector
          this.nodeData.data.next_step.behavior = this.behavior
        } else {
          this.outputResponseItem.next_step.dialog_node = this.dialog_node
          this.outputResponseItem.next_step.selector = this.selector
          this.outputResponseItem.next_step.behavior = this.behavior
          this.selector = ''
          this.behavior = ''
          this.dialog_node = ''
          this.$forceUpdate()
        }
      }
    }
  },
  computed: {
    ...mapFields('dialogEdit', {
      editDialog: 'editDialog',
      customizeResponseDialog: 'customizeResponseDialog',
      selectNodeModeValue: 'selectNodeMode.value',
      selectNodeModeActive: 'selectNodeMode.active',
      selectNodeModeOutputResponseIndex: 'selectNodeMode.outputResponseIndex',
      selectNodeModeDialogTitle: 'selectNodeMode.dialogTitle'
    }),
    ...mapFields('dialogEdit', {
      behavior: 'nodeJumpSelect.behavior',
      dialog_node: 'nodeJumpSelect.dialog_node',
      selector: 'nodeJumpSelect.selector'
    }),
    isNotCheckedOut () {
      return !this.$store.getters['snapshots/userCanEdit']
    }
  },
  created () {
    if (!this.outputResponseItem.next_step) {
      this.outputResponseItem.next_step = {
        behavior: 'skip_user_input'
      }
    }
    this.selectedBehavior = this.outputResponseItem.next_step.behavior
    this.noAction =
        typeof this.outputResponseItem.actions === typeof undefined ||
        this.outputResponseItem.actions === []
    this.tabs = this.outputResponseItem.actions?.length || 0
  },
  mounted () {
    // console.log('mounting')
  },
  methods: {
    updateResponseItemFromJson (e) {
      if (e) {
        this.outputResponseItem.context = e.context
        this.outputResponseItem.output = e.output
        this.outputResponseItem.actions = e.actions
      }
    },
    toggleJSON () {
      this.jsonOpen = !this.jsonOpen
    },
    addResponseCustomized (index) {
      const outputResposnse = this.nodeData.data.outputResponses[index]
      outputResposnse.output.generic.push({
        values: [
          {
            text: ''
          }
        ],
        response_type: 'text',
        selection_policy: 'sequential'
      })
    },
    changedSelectedBehavior () {
      this.$forceUpdate()
      if (this.selectedBehavior !== 'jump_to') {
        this.outputResponseItem.next_step.behavior = this.selectedBehavior
        delete this.outputResponseItem.next_step.dialog_node
        delete this.outputResponseItem.next_step.selector
      } else {
        this.toSelectNode()
      }
    },
    toSelectNode () {
      // console.log('active = true')
      this.selectNodeModeActive = true
      this.selectNodeModeValue = 1
      this.selectNodeModeOutputResponseIndex = this.outputResponseIndex
      this.selectNodeModeDialogTitle =
        this.nodeData.data.title === ''
          ? this.outputResponseItem.conditions
          : this.nodeData.data.title +
            ' > ' +
            this.outputResponseItem.conditions
      this.$emit('close-customize-response-dialog')
      this.editDialog = false
      this.topMenu = true
    },
    loopAssisRecNode (node) {
      return node.data.conditions
    },
    respostas (node) {
      return (
        node?.data?.output?.generic?.length ||
        node?.data?.outputResponses?.length ||
        0
      )
    },
    returnContext (node) {
      if (!node.data?.metadata?._customization?.mcr) {
        // se não tiver customização de respostas
        if (node.data.context) {
          return Object.keys(node.data.context).length + ' '
        } else return '0 '
      } else {
        let customContexts = {}
        for (let i = 0; i < node.data.outputResponses.length; i++) {
          customContexts = {
            ...customContexts,
            ...node.data.outputResponses[i]
          }
        }
        return Object.keys(customContexts).length + ' '
      }
    },
    scrollToNode (id) {
      // console.log('opa')
      const node = this.nodeMap[id]
      let parent = node.data.parent
      while (parent) {
        const nodeParent = this.nodeMap[parent]
        nodeParent.$folded = false
        parent = nodeParent.data.parent
      }
      this.customizeResponseDialog = false
      this.$emit('scrollNodeCustomize', node)
    },
    addValueText (valuesArr, index) {
      // just to add { text: "" } inside array values if it doesn't exist
      if (!valuesArr.length) {
        this.nodeData.data.output.generic[index].values = [{ text: '' }]
      }
      return valuesArr
    },
    newTab () {
      let newAction = {
        name: 'ApiRequest',
        parameters: {},
        type: 'client',
        result_variable: 'success'
      }
      // console.log(this.nodeData)
      if (
        !this.outputResponseItem.actions ||
        this.outputResponseItem.actions.length === 0
      ) {
        // console.log('não tem actions')
        this.outputResponseItem.actions = [newAction]
        this.tabs = 1
        this.$nextTick(() => {
          this.actionsTab = `tab-1`
          // console.log(this.actionsTab)
          this.noAction = false
        })
      } else {
        // console.log('tem actions')
        this.outputResponseItem.actions.push(newAction)
        // this.actionsTab = 'tab-' + this.outputResponseItem.actions.length
        this.tabs += 1
        this.$nextTick(function () {
          this.actionsTab = `tab-${this.tabs}`
          // console.log('newActionstabl', this.actionsTab)
        })
      }
    },
    removeTab (i) {
      // console.log('i', i)
      if (`tab-${i}` === this.actionsTab) {
        let prevTab = i - 1
        this.actionsTab = 'tab-' + prevTab
      }
      // console.log(this.outputResponseItem.actions)
      setTimeout(() => {
        this.outputResponseItem.actions.splice(i - 1, 1)
        this.tabs = this.tabs - 1
        if (this.outputResponseItem.actions.length === 0) {
          // console.log('noAction')
          this.noAction = true
        }
      }, 100)
    }
  }
}
</script>

<style scoped>
.contQuill {
  display: flex;
  flex-direction: column;
}
.titleLabel {
  width: 100%;
  font-size: 20px;
  line-height: 30px;
}
.colorDark {
  color: #393939;
}
.variationSelected {
  color: #0f62fe;
  font-weight: 400;
  letter-spacing: 0.16px;
  cursor: pointer;
}
.variationSelected:hover {
  text-decoration: underline;
}
.md-button.md-facebook {
  background-color: #0f62fe !important;
}
.md-button.md-facebook:hover,
.md-button.md-facebook:focus,
.md-button.md-facebook:active,
.md-button.md-facebook.active,
.md-button.md-facebook:active:focus,
.md-button.md-facebook:active:hover,
.md-button.md-facebook.active:focus,
.md-button.md-facebook.active:hover {
  background-color: #0f62fe !important;
  color: #fff !important;
  -webkit-box-shadow: 0 14px 26px -12px rgba(59, 89, 152, 0.42),
    0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(59, 89, 152, 0.2) !important;
  box-shadow: 0 14px 26px -12px rgba(59, 89, 152, 0.42),
    0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(59, 89, 152, 0.2) !important;
}
.md-menu-content.md-menu-content-medium {
  z-index: 204 !important;
}
.md-menu-content.md-menu-content-small {
  z-index: 204 !important;
}
.md-tooltip {
  height: 22px !important;
  padding: 8px !important;
  position: absolute !important;
  z-index: 9999 !important;
  pointer-events: none !important;
  border-radius: 2px !important;
  border-top-left-radius: 2px !important;
  border-top-right-radius: 2px !important;
  border-bottom-right-radius: 2px !important;
  border-bottom-left-radius: 2px !important;
  transition: 0.15s cubic-bezier(0, 0, 0.2, 1) !important;
  transition-property: opacity, transform !important;
  will-change: opacity, transform, top, left !important;
  font-size: 10px !important;
  line-height: 22px !important;
  text-transform: none !important;
  white-space: nowrap !important;
  min-width: none !important;
  width: 170px !important;
  max-width: 1000px !important;
  height: auto !important;
  line-height: 20px !important;
  text-align: center !important;
  border-radius: 3px !important;
  background-color: rgba(97, 97, 97, 0.9) !important;
  color: white !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  white-space: normal !important;
  box-shadow: none !important;
}
.md-tooltip:after {
  opacity: 0;
}
</style>
